<template>
    <el-dialog
        title="选择调查问卷"
        :visible.sync="value"
        top="5vh"
        custom-class="survey-selector-dialog"
        :close-on-click-modal="false"
        :modal-append-to-body="false"
        width="70%">

        <div class="dialog-body">
            <ul class="tips">
                <li>1、每个问卷只可作答一次，选择已有问卷会读取历史作答记录</li>
                <li>2、如需重新调查请使用模版创建新问卷</li>
            </ul>

            <data-tables ref="surveyTable"
                         :data="tableData"
                         :table-props="tableProps"
                         :page-size="20"
                         :pagination-props="{pageSizes: [20, 50, 100]}"
                         header-align="center"
                         @selection-change="handleSelectionChange"
                         v-loading="loading"
            >
                <!-- column checkbox -->
                <el-table-column
                    type="selection"
                    width="55px"
                    :reserve-selection="true"
                    :selectable="isCheckboxSelectable"
                    align="center">
                </el-table-column>

<!--                <el-table-column label="#" type="index" width="40" align="center"></el-table-column>-->
                <el-table-column v-for="(title,index) in titles" :prop="title.prop" :label="title.label" :key="index"
                                 sortable="custom"
                                 show-overflow-tooltip
                                 align="center">
                </el-table-column>
            </data-tables>
            <el-button class="btn-refresh" @click="refreshData" size="small" icon="el-icon-refresh">刷新数据</el-button>
        </div>

        <div slot="footer" class="dialog-footer">
            <el-button @click="toNewTag" type="text">> 前往 "调查问卷"</el-button>
            <div class="btn-group">
                <el-button type="success" @click="selectOver">{{$t('c.confirm')}}</el-button>
                <el-button @click="close">{{$t('c.cancel')}}</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>

export default {
    components: {},

    props: {
        // 打开/关闭弹框，直接用v-model即可
        value: {
            type: Boolean,
            default: false,
        },
        // 初始化加载的id数组
        initIds: {
            type: Array
        }
    },

    data() {
        return {
            selectData: [],
            tableData: [],
            tableProps: {
                border: false,
                stripe: true,
                rowKey: row => row.id,
                height: '50vh'
            },
            titles: [
                {
                    prop: 'name',
                    label: this.$t('questionnaire.name'),
                }, {
                    prop: 'participants',
                    label: this.$t('questionnaire.peopleNum')
                }, {
                    prop: 'createTime',
                    label: this.$t('c.creationTime')
                },
                {
                    prop: 'creatorName',
                    label: this.$t('c.creator')
                }
            ],
            loading: false,
        }
    },

    methods: {
        initDialog() {
            this.query();
        },

        async query() {
            let res = await this.$api.getQuestionnaires()

            this.tableData = res.package
            this.tableData.forEach(val => {
                val.resType = 4;
                val.businessId = val.id;
            });

            let elTable = this.$refs.surveyTable.$refs.elTable

            this.tableData.forEach(row => {
                if (this.initIds.includes(row.id)) {
                    elTable.toggleRowSelection(row, true)
                }
            })

            return res
        },

        async refreshData() {
            this.loading = true
            await this.query()
            await new Promise(resolve => setTimeout(resolve, 300))
            this.loading = false
        },

        handleSelectionChange(arr) {
            this.selectData = arr
        },
        selectOver() {
            let newSelectData = this.selectData.filter(item => !this.initIds.includes(item.id))
            this.$emit('onSelectOver', newSelectData);
            this.close()
        },

        isCheckboxSelectable(row) {
            return !this.initIds.includes(row.id)
        },

        toNewTag() {
            window.open('/statistics/questionnaire')
        },

        close() {
            this.$emit('input', false)
        }
    },

    watch: {
        value(val) {
            // 打开
            if (val) {
                this.initDialog();
                // 关闭
            } else {
                let topicTable = this.$refs.surveyTable.$refs.elTable;
                topicTable.clearSelection();
                this.$emit('input', false)
            }
        },
    },
}
</script>

<style lang="scss">
    .survey-selector-dialog {

        .el-dialog__header {
            padding: 10px 15px;
            border-bottom: 1px solid #ccc;
        }
        .el-dialog__body {
            padding-top: 20px;
            background-color: #F8F8F8;
        }
        .el-dialog__footer {
            padding: 10px 20px;
        }
        .el-card__body {
            padding: 15px 20px;
        }

        .dialog-body {
            position: relative;
            .btn-refresh {
                position: absolute;
                bottom: 5px;
            }
        }

        .tips {
            margin-top: -10px;
            margin-bottom: 10px;
            padding-left: 10px;
            color: #666;
            font-size: 13px;
            line-height: 1.8;
            border-left: 4px solid #ccc;
        }

        .dialog-footer {
            display: flex;
            justify-content: space-between;
            .btn-group {
                button {
                    min-width: 110px;
                    letter-spacing: 4px;
                }
            }
        }

    }
</style>
